import { createAction } from '@reduxjs/toolkit';
import type {
  BoundaryStatsItem, StatItemMetricData,
} from './stats.state';

export const addBoundaryStatsItems = createAction(
  'STATS_BOUNDARY_ADD_ITEMS',
  (newItems: ReadonlyArray<StatItemMetricData>) => ({
    payload: {
      newItems,
    },
  })
);

export const updateBoundaryStatsItems = createAction(
  'STATS_BOUNDARY_UPDATE_ITEMS',
  (items: ReadonlyArray<BoundaryStatsItem>) => ({
    payload: {
      items,
    },
  })
);
